// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3pEmo","signatureButtonsRight":"ModalSign_signatureButtonsRight__JCwKE"};